import { connect } from "react-redux";
import { setAccount } from "./features/account/accountSlice";
import { setCompany } from "./features/account/companySlice";
import { setLoggedIn } from "./features/account/loginSlice";
import { useEffect, useMemo } from "react";
import { hidePreloader } from "./library/helper";
import cookies from "js-cookie";
import { Navigate, useLocation } from "react-router-dom";

function Guard(props) {
  const { loggedIn, account } = props;
  const location = useLocation();

  const isOnboardingRoute = useMemo(() => {
    const p = location.pathname;
    return p === "/onboard" || p.startsWith("/onboard/");
  }, [location.pathname]);

  const isWaitingApprovalRoute = location.pathname === "/waiting-approval";

  useEffect(() => {
    const base = process.env.REACT_APP_BASE_SERVER;
    if (!base) return;

    const signedInKey = `${new URL(base).hostname}_signedIn`;
    const cookieVal = cookies.get(signedInKey);
    props.setLoggedIn(cookieVal === "true");

    const sync = (e) => {
      const { changed = [], deleted = [] } = e || {};
      if (changed.some((c) => c.name === signedInKey)) {
        props.setLoggedIn(changed.find((c) => c.name === signedInKey)?.value === "true");
      }
      if (deleted.some((c) => c.name === signedInKey)) {
        props.setLoggedIn(false);
      }
    };

    window.cookieStore?.addEventListener("change", sync);
    return () => window.cookieStore?.removeEventListener("change", sync);
  }, []);

  // helpers to tolerate snake_case / camelCase
  const userId = account?.user_id
  const clientId = account?.client_id
  const clientOnboard = account?.client_onboard
  const clientSubs = account?.client_subscription

  useEffect(() => {
    if (loggedIn !== "waiting" && loggedIn && userId) {
      sessionStorage.removeItem("loginRedirected");
    }
  }, [loggedIn, userId]);

  if (loggedIn === "waiting") return null;

  if (!loggedIn) {
    const alreadyRedirected = sessionStorage.getItem("loginRedirected") === "1";
    if (!alreadyRedirected) {
      sessionStorage.setItem("loginRedirected", "1");
      const url = [
        process.env.REACT_APP_ACCOUNT_URL,
        "/login?",
        `redirect_=${encodeURIComponent(window.location.href)}`,
      ].join("");
      window.location.assign(url);
    }
    return null;
  }

  if (!userId) return null;

  const needsOnboarding = !clientId || !clientOnboard;

  if (needsOnboarding) {
    if (!isOnboardingRoute) {
      return <Navigate to="/onboard" replace state={{ from: location }} />;
    }
    return props.children;
  }

  if (clientOnboard && isOnboardingRoute) {
    return <Navigate to="/dashboard" replace state={{ from: location }} />;
  }

  if (clientSubs === -1 && clientOnboard === 1 && !isWaitingApprovalRoute) {
    return <Navigate to="/waiting-approval" replace state={{ from: location }} />;
  }

  if (clientSubs !== -1 && isWaitingApprovalRoute) {
    return <Navigate to="/dashboard" replace state={{ from: location }} />;
  }

  return props.children;
}

const mapStateToProps = (state) => ({
  count: state.counter.value,
  loggedIn: state.loggedIn.value,
  account: state.account.value,
  company: state.company.value,
});

const mapDispatchToProps = {
  setLoggedIn,
  setAccount,
  setCompany,
};

export default connect(mapStateToProps, mapDispatchToProps)(Guard);
